export const api = process.env.REACT_APP_API_URI;

// export const api = "https://localhost:44334/api";
